export const RETENTION_GLOSSARY = [
  {
    key: 'retention.cohortType',
    label: 'Coorte de',
    whatIs: 'Escolhe quem é acompanhado: Usuários (pessoas, pela 1ª ação de uso real) ou Empresas (pelo mês da 1ª batida de ponto).',
    purpose: 'Usuários mostra se as pessoas continuam usando; Empresas mostra se as contas continuam ativas depois de começar.',
    howGenerated: 'A escolha fica só nesta sessão do navegador. Empresas só existem por mês; ao voltar para Usuários, a granularidade escolhida antes volta.',
    seeAlso: ['retention.granularity'],
  },
  {
    key: 'retention.granularity',
    label: 'Granularidade da retenção',
    whatIs: 'Tamanho de cada período da matriz: dia (D0 a D30), semana (W0 a W12, semanas começando na segunda) ou mês (M0 a M12).',
    purpose: 'Dia mostra o abandono logo depois do início; semana e mês mostram a permanência ao longo do tempo.',
    howGenerated: 'Cada granularidade é um cálculo próprio, feito toda madrugada pelo processamento das coortes. Empresas só por mês.',
  },
  {
    key: 'retention.userRetention',
    label: 'Retenção de usuários',
    whatIs: 'Parte das pessoas de uma coorte que voltou a ter ação de uso real em algum período depois daquele em que começou, acumulada até cada período.',
    purpose: 'Mostra se quem começa a usar o produto continua usando; queda forte nos primeiros períodos indica problema de primeira experiência.',
    howGenerated: 'Coorte = dia, semana ou mês da 1ª ação de uso real da pessoa na empresa. Célula = quem voltou entre o período 1 e o N ÷ tamanho da coorte. Agregados diários, dia local da empresa.',
    caveat: 'A pessoa em duas empresas está em duas coortes. Quem foi criado antes do início da coleta do seu banco fica fora.',
    metricKey: 'retention_user',
  },
  {
    key: 'retention.companyRetention',
    label: 'Retenção de empresas',
    whatIs: 'Parte das empresas de uma coorte que voltou a ter algum usuário ativo em algum mês depois do mês em que ativou, acumulada até cada mês.',
    purpose: 'Mostra se as contas que começaram a usar o ponto seguem em uso nos meses seguintes.',
    howGenerated: 'Coorte = mês da 1ª batida de funcionário ou gestor, se ela veio em até 30 dias da criação da empresa. Célula = empresas com uso em algum mês de 1 a N ÷ empresas da coorte.',
    caveat: 'A coorte segue a regra antiga de ativação, contada da criação da empresa, e não da venda como a Ativação. Inclui empresas que hoje estão inativas.',
    metricKey: 'retention_company',
  },
  {
    key: 'retention.cohort',
    label: 'Coorte',
    whatIs: 'Data de início do grupo: o dia, a segunda-feira da semana ou o 1º dia do mês em que os membros começaram. O selo "retroativo" marca coortes calculadas a partir do histórico.',
    purpose: 'Compara turmas que começaram em momentos diferentes, por exemplo antes e depois de uma mudança no produto.',
    howGenerated: 'Coortes do período escolhido no filtro, até ontem. Coortes que começam antes da cobertura da coleta mais um período não são calculadas e aparecem numa nota.',
    seeAlso: ['retention.derived', 'common.coverage'],
  },
  {
    key: 'retention.cohortSize',
    label: 'Tamanho da coorte',
    whatIs: 'Quantos usuários (ou empresas) começaram no período da coorte. É o denominador de todas as células da linha.',
    purpose: 'Mostra quanto cada ponto percentual representa; coortes pequenas oscilam mais.',
    howGenerated: 'Contagem dos membros da coorte gravada pelo processamento noturno das coortes.',
    seeAlso: ['retention.companies'],
  },
  {
    key: 'retention.companies',
    label: 'Empresas representadas',
    whatIs: 'Em quantas empresas diferentes estão os usuários da coorte.',
    purpose: 'Avisa quando uma coorte grande vem de poucas empresas: uma empresa só pode puxar a retenção para cima ou para baixo.',
    howGenerated: 'Contagem de empresas distintas entre os membros da coorte, gravada junto com ela.',
  },
  {
    key: 'retention.derived',
    label: 'Coorte retroativa',
    whatIs: 'Coorte calculada a partir do histórico já gravado nos bancos dos clientes, e não só de eventos coletados ao vivo.',
    purpose: 'Avisa que a coorte foi medida de outro jeito; leia como tendência ao comparar com coortes ao vivo.',
    howGenerated: 'Marcada quando nenhum membro da coorte veio de evento coletado ao vivo, só de dados derivados ou retroativos.',
    seeAlso: ['common.state.derived'],
  },
  {
    key: 'retention.offset',
    label: 'Período desde o início (D, W, M)',
    whatIs: 'Retenção acumulada N períodos depois do início: D7 = 7 dias, W4 = 4 semanas, M3 = 3 meses. D0, W0 e M0 são o próprio período de início e valem 100%.',
    purpose: 'Mostra quanto da coorte continua; comparar a mesma coluna entre coortes revela se a retenção melhora ou piora.',
    howGenerated: 'Membros que voltaram em algum período de 1 a N ÷ tamanho da coorte. A célula só sai quando o período N termina; antes disso aparece "pendente dd/mm". O exato do período aparece no mouse.',
    caveat: 'Célula pendente não é zero. Cor mais escura = retenção maior.',
    seeAlso: ['retention.pending'],
  },
  {
    key: 'retention.pending',
    label: 'Célula pendente',
    whatIs: 'Período que ainda não terminou para a coorte, por isso sem valor. Na exportação, a primeira célula pendente da linha e a data em que ela sai.',
    purpose: 'Evita comparar coortes recentes, ainda em andamento, com coortes maduras.',
    howGenerated: 'A data mostrada é o último dia do período N; o processamento das coortes da madrugada seguinte grava o valor.',
    seeAlso: ['common.state.immature'],
  },
  {
    key: 'retention.weightedAverage',
    label: 'Média ponderada das coortes maduras',
    whatIs: 'Retenção média em cada marco principal (por exemplo W1, W4, W8 e W12), pesando cada coorte pelo seu tamanho.',
    purpose: 'Dá um número de referência para comparar cada coorte: abaixo da média, a turma retém pior que o habitual.',
    howGenerated: 'Soma dos retidos acumulados das coortes maduras naquele marco ÷ soma dos tamanhos delas. Coortes pendentes no marco ficam fora.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/retention.js